import * as echarts from 'echarts';
import { useEffect, useRef, useState } from 'react';

/**
 * @description
 *
 */
interface IProps {
  data: any;
  xAxisField: string;
  yAxisField: string;
  xAxisName?: string;
  yAxisName?: string;
  yAxisScale?: boolean;
  legendField?: string;
  series: { name: string; key: string }[];
  style?: any;
  title?: any;
  yAxisLabelFormatter?: Function;
  xAxisLabelFormatter?: Function;
  yAxisValueFormatter?: Function;
  xAxisValueFormatter?: Function;
  tooltipValueFormatter?: any;
  tooltipFormatter?: any;
  grid?: { [index: string]: any };
}

const LineChart = ({
  data,
  yAxisField,
  xAxisField,
  series,
  style = { width: '100%', height: 260 },
  title,
  ...props
}: IProps) => {
  const chartRef = useRef();
  const [chart, setChart] = useState(null);

  useEffect(() => {
    setChart(echarts.init(chartRef.current));
  }, []);
  useEffect(() => {
    if (chart) {
      window.addEventListener('resize', () => {
        chart.resize();
      });
    }
  }, [chart]);

  useEffect(() => {
    loadChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, chart]);

  const options = {
    animation: true,
    color: ['#326BFB', '#FFAA00'],
    title: title && {
      text: title,
      textStyle: {
        color: '#999999',
        fontSize: 14,
        fontWeight: 400,
      },
      left: 0,
      top: 0,
    },
    grid: Object.assign(
      {},
      {
        left: 12,
        right: 44,
        top: '15%',
        bottom: '10%',
        containLabel: true,
        filterMode: 'none',
      },
      props.grid
    ),
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#fff',
      padding: 12,
      textStyle: {
        color: '#000',
        lineHeight: '25px',
      },
      valueFormatter: props.tooltipValueFormatter,
      formatter: props.tooltipFormatter,
    },
    legend: {
      right: 12,
      top: 0,
      orient: 'horizontal',
      itemGap: 24,
      icon: 'rect',
      itemHeight: 8,
      itemWidth: 8,
      textStyle: {
        color: '#999999',
        fontSize: 12,
      },
    },
    xAxis: {
      name: props.xAxisName,
      type: 'value',
      splitNumber: 3,
      data: [],
      axisLabel: {
        color: 'rgba(0,0,0,0.5)',
        formatter: props.xAxisLabelFormatter,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#C4C4C4',
        },
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      lineStyle: {
        width: 3,
      },
    },
    yAxis: {
      name: props.yAxisName,
      type: 'value',
      splitNumber: 3,
      scale: props.yAxisScale,
      axisLabel: {
        color: '#A0A4AA',
        formatter: props.yAxisLabelFormatter,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        // 坐标中的网格线
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#F0F2F5',
        },
      },
    },
    series: [],
  };

  function loadChart() {
    if (data && chart) {
      chart.showLoading();
      chart.clear();
      const seriesTemp = [];
      series.forEach((item) => {
        const temp = {
          type: 'line',
          name: item.name,
          data: data[item.key]?.map((dataItem) => [
            dataItem[xAxisField],
            dataItem[yAxisField],
          ]),
          smooth: 0.3,
          symbol: 'none',
        };
        seriesTemp.push(temp);
      });
      options.series = seriesTemp;
      chart.setOption(options);
      chart.hideLoading();
    }
  }

  return (
    <>
      <div ref={chartRef} style={style} />
    </>
  );
};

export default LineChart;
